import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createVNode as _createVNode, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, unref as _unref, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "section-title large" }
const _hoisted_2 = { class: "description" }
const _hoisted_3 = { class: "filter-tabs" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "filter-content" }
const _hoisted_6 = {
  key: 0,
  class: "date-filter"
}
const _hoisted_7 = {
  key: 1,
  class: "game-filter"
}
const _hoisted_8 = { value: "" }
const _hoisted_9 = ["value"]
const _hoisted_10 = {
  key: 2,
  class: "draw-filter"
}
const _hoisted_11 = ["placeholder"]
const _hoisted_12 = {
  key: 0,
  class: "account-required",
  role: "alert"
}
const _hoisted_13 = {
  key: 1,
  class: "results-grid"
}
const _hoisted_14 = {
  key: 2,
  class: "load-more"
}
const _hoisted_15 = ["disabled"]
const _hoisted_16 = {
  key: 3,
  class: "results-status"
}
const _hoisted_17 = {
  key: 4,
  class: "results-status"
}

import { ref, computed, watch, onMounted } from 'vue'

import LotteryResultCard from '@/components/LotteryResultCard.vue'
import NextDrawsFilter from '@/components/NextDrawsFilter.vue'
import { useResultsStore } from '@/stores/results'
import { useGameStore } from '@/stores/game'
import { useRouter, useRoute } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import { useI18n } from 'vue-i18n'

export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'ResultsView'
},
  __name: 'ResultsView',
  setup(__props) {



const showDatePicker = ref(false);
const gameStore = useGameStore()
const resultsStore = useResultsStore();
const router = useRouter()
const route = useRoute()
const authStore = useAuthStore()
const { t } = useI18n()

const tabs = computed(() => [
  { id: 'by-date', label: t('results.byDate') },
  { id: 'by-lottery', label: t('results.byGame') },
  { id: 'by-drawid', label: t('results.byDrawId') }
]);

const isEmbedResults = computed(() => route.meta.minimalChrome === true)

const missingAccount = computed(() => {
  if (route.meta.requiresAccount !== true) return false
  const account = authStore.account || sessionStorage.getItem('auth_account')
  return !account || !String(account).trim()
})

const activeTab = ref('by-lottery'); // Default to BY GAME
const selectedDate = ref(new Date().toISOString().split('T')[0]);
const selectedGame = ref('');
const drawId = ref('');

const hasMoreResults = computed(() => {
  const currentPage = Number(resultsStore.pagination.current_page || 1);
  const totalPages = Number(resultsStore.pagination.total_pages || 1);
  return currentPage < totalPages;
});

const loadMore = () => {
  resultsStore.loadMore();
};

const handleDateFilter = (date: string) => {
  selectedDate.value = date || new Date().toISOString().split('T')[0];
};

const handleBet = async (game: any) => {
  if (!game?.game_slug) return
  await gameStore.fetchGameDetails(game.game_slug)
  router.push(`/lottery/${game.game_slug}`)
}

const gamesList = computed(() => {
  // Use game store to show ALL games, not just games with results
  const allGames = gameStore.getProducts || [];
  if (!Array.isArray(allGames)) return [];
  
  // Sort games alphabetically by name
  return [...allGames].sort((a, b) => {
    const nameA = a.name?.toLowerCase() || '';
    const nameB = b.name?.toLowerCase() || '';
    return nameA.localeCompare(nameB);
  });
});

watch(activeTab, (newTab, oldTab) => {
  if (oldTab === 'by-lottery' && newTab !== 'by-lottery') {
    selectedGame.value = '';
  }
});

watch(
  [activeTab, selectedDate, selectedGame, drawId, missingAccount],
  () => {
    if (missingAccount.value) return
    const filters: any = {
      drawDate: '',
      drawId: '',
      drawType: '',
      gameSlug: ''
    };

    if (activeTab.value === 'by-date') {
      filters.drawType = 'by-date';
      filters.drawDate = selectedDate.value || '';
    } else if (activeTab.value === 'by-lottery') {
      filters.drawType = 'by-lottery';
      filters.gameSlug = selectedGame.value || '';
    } else if (activeTab.value === 'by-drawid') {
      filters.drawType = 'draw';
      filters.drawId = drawId.value || '';
    }

    resultsStore.setFilters(filters);
    resultsStore.fetchResults(1);
  }
);

onMounted(async () => {
  if (missingAccount.value) return
  // Fetch all products (games) to populate the dropdown immediately
  if (!gameStore.getProducts || gameStore.getProducts.length === 0) {
    await gameStore.fetchProducts();
  }
  // Set filters for BY GAME mode by default
  resultsStore.setFilters({ 
    drawType: 'by-lottery',
    gameSlug: selectedGame.value || ''
  });
  resultsStore.fetchResults(1);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["results", { 'embed-results': isEmbedResults.value }])
  }, [
    _createElementVNode("h2", _hoisted_1, _toDisplayString(_ctx.$t('results.title')), 1),
    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t('results.description')), 1),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabs.value, (tab) => {
        return (_openBlock(), _createElementBlock("button", {
          key: tab.id,
          class: _normalizeClass(["tab-button", { active: activeTab.value === tab.id }]),
          onClick: ($event: any) => (activeTab.value = tab.id)
        }, _toDisplayString(tab.label), 11, _hoisted_4))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_5, [
      (activeTab.value === 'by-date')
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(NextDrawsFilter, {
              modelValue: selectedDate.value,
              "onUpdate:modelValue": [
                _cache[0] || (_cache[0] = ($event: any) => ((selectedDate).value = $event)),
                handleDateFilter
              ],
              "show-date-picker": showDatePicker.value,
              "allow-past": true
            }, null, 8, ["modelValue", "show-date-picker"])
          ]))
        : _createCommentVNode("", true),
      (activeTab.value === 'by-lottery')
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedGame).value = $event)),
              class: "game-select"
            }, [
              _createElementVNode("option", _hoisted_8, _toDisplayString(_ctx.$t('results.allGames')), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(gamesList.value, (game) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: game.slug,
                  value: game.slug
                }, _toDisplayString(game.name), 9, _hoisted_9))
              }), 128))
            ], 512), [
              [_vModelSelect, selectedGame.value]
            ])
          ]))
        : _createCommentVNode("", true),
      (activeTab.value === 'by-drawid')
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((drawId).value = $event)),
              type: "text",
              placeholder: _ctx.$t('results.enterDrawId'),
              class: "draw-input"
            }, null, 8, _hoisted_11), [
              [_vModelText, drawId.value]
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (missingAccount.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.$t('results.accountRequired')), 1))
      : (_openBlock(), _createElementBlock("div", _hoisted_13, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(resultsStore).results, (result) => {
            return (_openBlock(), _createBlock(LotteryResultCard, {
              key: result.id,
              lottery: result,
              onBet: ($event: any) => (handleBet(result))
            }, null, 8, ["lottery", "onBet"]))
          }), 128))
        ])),
    (!missingAccount.value && hasMoreResults.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createElementVNode("button", {
            class: "load-more-button",
            disabled: _unref(resultsStore).loading,
            onClick: loadMore
          }, _toDisplayString(_ctx.$t('results.loadMore')), 9, _hoisted_15)
        ]))
      : _createCommentVNode("", true),
    (_unref(resultsStore).loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_ctx.$t('common.loading')), 1))
      : (_unref(resultsStore).error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_unref(resultsStore).error), 1))
        : _createCommentVNode("", true)
  ], 2))
}
}

})